import type { Editor as TiptapEditor } from '@tiptap/core';

import { getMarkdown } from '../components/markdown-utils';

export const DOCUMENT_WIDTH = '85ch';
export const PENDING_AI_GENERATION = 'AI_GENERATION';

export const getDocumentMarkdown = ({
  editor,
  markdown,
  content,
}: {
  editor?: TiptapEditor | null;
  markdown?: string | null;
  content?: unknown;
}): string => {
  if (typeof markdown === 'string' && markdown.trim()) {
    return markdown;
  }

  if (typeof content === 'string' && content.trim()) {
    return content;
  }

  return editor ? getMarkdown(editor) : '';
};

// For workflow resources (e.g. "workflows/abc/instances/xyz"), uses the
// instance ID. For other resources, replaces slashes with dashes.
export function getCollaborativeDocumentName(resource: string): string {
  if (resource.startsWith('collaborativeDocuments/')) {
    return resource;
  }

  const parts = resource.split('/');
  const isWorkflowResource = parts.length >= 4 && parts[0] === 'workflows';

  const collaborativeDocumentId = isWorkflowResource
    ? parts[3]
    : resource.replace(/\//g, '-');

  return `collaborativeDocuments/${collaborativeDocumentId}`;
}
